<template>
  <div v-if="tags.length > 0" class="dealer-details">
    <h4>{{"dealers.results.moreInfo" | t}}</h4>
    <div class="tags-container">
      <div v-for="(tag, i) in tags" :key="`${i}`" class="tag icon">
        <TagIcon :tag="tag" />
      </div>
    </div>
  </div>
</template>

<script>
import refJson from "@/assets/fonts/stihl-icons/index.json";
import TagIcon from "../components/TagIcon";

export default {
  name: "DealerDetails",
  data() {
    return {
      iconRef: refJson
    };
  },
  props: {
    details: {
      type: Array,
      default() {
        return [];
      }
    },
    dealerTags: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    tags() {
      return this.getDealerTags();
    }
  },
  methods: {
    getDealerTags() {
      for (let i = 0; i < this.iconRef.length; i++) {
        const t = this.iconRef[i];
        if (this.details.includes(t.showForTags[0])) {
          this.dealerTags.push(t);
        }
      }
      return this.dealerTags;
    }
  },
  components: {
    TagIcon
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dealer-details {
  flex-direction: column;
  margin-bottom: $gutter-lg;

  h4 {
    font-family: $font-title;
    font-size: 1.285em;
    border-bottom: 1px solid #c8c8c8;
    text-align: left;
    padding: 0 0 $gutter-sm;
    margin: 0 0 $gutter-md;
  }
  .tags-container {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 0;
  }
  .tag {
    font-weight: normal;
    font-size: 1.14em;
    line-height: 1.14em;
    display: flex;
    box-sizing: border-box;
    margin-bottom: $gutter-md;
    cursor: pointer;
    color: $text-primary;
    width: 33.33%;
  }
  @media only screen and (max-width: $breakpoint-md) {
    .tag {
      width: 100%;
      margin-bottom: 1em;
    }
  }
  .tag span::before {
    font-family: $font-icons;
    line-height: 1;
    vertical-align: middle;
    font-size: 1.785em;
    color: $text-muted;
    margin-right: .2em;
  }
}
</style>
